$(function () {
  const mobileMenu = $('#mobile-menu');
  const body = $('#page-body');
  const homepageWrapper = $('.homepage-wrapper');

  $('#hamburger-menu-btn').click(() => {
    mobileMenu.removeClass('v2-translate-x-full');
    mobileMenu.addClass('v2-translate-x-0');
    body.addClass('v2-h-screen');
    homepageWrapper.addClass('v2-overflow-y-hidden');
  });

  $('#mobile-menu-close-btn').click(() => {
    mobileMenu.removeClass('v2-translate-x-0');
    mobileMenu.addClass('v2-translate-x-full');
    body.removeClass('v2-h-screen');
    homepageWrapper.removeClass('v2-overflow-y-hidden');
  });
});
